import styled from '@benzinga/themetron';
import { SearchTool } from './SearchBarTool';
import React from 'react';
import { SearchBarProps, SearchBarState } from '../SearchBar';
import { Wrap } from '@benzinga/themed-icons';

export const WRAP_TOOL_ID = 'wrap' as const;

export interface WrapTool extends SearchTool {
  id: typeof WRAP_TOOL_ID;
}

export const createWrapTool = (
  onClick: (setSearchBarState: React.Dispatch<React.SetStateAction<SearchBarState>>) => void,
): WrapTool => {
  return {
    getTool: (_: SearchBarProps, searchBarState, setSearchBarState) => {
      const ModeDisplay = searchBarState.expandedMode ? ActiveWrap : InactiveWrap;
      return (
        (searchBarState.horizontalOverflow || searchBarState.expandedMode) && (
          <ModeDisplay onClick={() => onClick(setSearchBarState)} />
        )
      );
    },
    id: WRAP_TOOL_ID,
  };
};

export function isWrapTool(tool: SearchTool): tool is WrapTool {
  return tool.id === WRAP_TOOL_ID;
}

export const useWrapTool = (
  onClick: (setSearchBarState: React.Dispatch<React.SetStateAction<SearchBarState>>) => void,
): WrapTool => {
  return React.useMemo(() => createWrapTool(onClick), [onClick]);
};

const ActiveWrap = styled(Wrap)`
  fill: ${props => props.theme.colors.brand};
  font-size: 24px;
  cursor: pointer;
  margin: 8px;
`;

const InactiveWrap = styled(Wrap)`
  fill: ${props => props.theme.colors.foregroundInactive};
  font-size: 24px;
  cursor: pointer;
  margin: 8px;
`;
